module.exports = __webpack_public_path__ + "static/media/placeholder10.3e2b8df7.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/placeholder10.jpg
// module id = 632
// module chunks = 0